import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { digitalCheckInSelector, fetchDigitalCheckInDetails } from '../AnalyticsSlice';
import moment from 'moment';
import CardWrapper from '../CardWrapper';
import {
  generateChartPdfExportData,
  generateTotalReservationExportData,
} from '../../../utils/analyticUtils';
import './digitalCheckIn.scss';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import zc from '@dvsl/zoomcharts';
import MyCustomFont from '../../../assets/fonts/customfont.ttf';
import { Drawer, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import StatisticsItemList from '../../statistics/statistics-item-list/StatisticsItemList';
import { ManageSearch } from '@mui/icons-material';
import { filteredHotelsSelector, selectedHotelSelector } from '../../property/propertySlice';
import Arrival from '../../statistics/arrival/Arrival';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';
import ExportPageAsCSV from '../../../utils/DigitalCheckInCsvExporter';
import { statisticsDataKeys } from '../Analytics';
import { getSelectedHotelName } from '../../../utils/commonUtils';
import SummaryCardWrapper from '../SummaryCardWrapper';

const digitalCheckInErrorKey = {
  checkIn: 'CHECK_IN',
  eRegistration: 'E_REG',
  payment: 'PAYMENT',
  keyGeneration: 'KEY_GENERATION',
  paymentFailures: 'Payment Failures',
  eRegistrationFailures: 'E-Registration Failures',
  keyGenerationFailures: 'Key Generation Failures',
  failedCheckIn: 'Check-ins Errors',
};

const DigitalCheckIn = (props) => {
  const {
    startDate,
    endDate,
    showAllForReport = false,
    hotelId,
    currentChannel,
    showLoader = () => {},
    setShowAllForReport = () => {},
  } = props;
  const dispatch = useDispatch();
  const digitalCheckInData = useSelector(digitalCheckInSelector);
  const [checkInAndOutChartData, setCheckInAndOutChartData] = useState([]);
  const selectedHotel = useSelector(selectedHotelSelector);
  const [upsellChartData, setUpsellChartData] = useState([]);
  const [checkInErrorList, setCheckInErrorList] = useState({});
  const [selectedErrorKey, setSelectedErrorKey] = useState({});
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [checkInErrors, setCheckInErrors] = useState([]);
  const selectedHotelList = useSelector(filteredHotelsSelector);
  const totalFailedCheckIns = (
    digitalCheckInData?.digitalCheckIn?.totalFailedCheckIns?.value || 0
  ).toLocaleString();

  const uniqueCheckInFailures = (
    digitalCheckInData?.digitalCheckIn?.uniqueCheckInFailures?.value || 0
  ).toLocaleString();
  const currentHotelName = getSelectedHotelName(selectedHotelList, selectedHotel);

  let TimeChart = zc.TimeChart;

  useEffect(() => {
    setCheckInErrors([
      ...(digitalCheckInData?.keyGenerationSuccessErrorTrend || [])?.map((error) => {
        return { Date: error?.date, keyError: error?.errorCount };
      }),
      ...(digitalCheckInData?.paymentSuccessErrorTrend || [])?.map((error) => {
        return { Date: error?.date, paymentError: error?.errorCount };
      }),
      ...(digitalCheckInData?.checkInSuccessErrorTrend || [])?.map((error) => {
        return { Date: error?.date, checkInError: error?.errorCount };
      }),
      ...(digitalCheckInData?.eRegistrationSuccessErrorTrend || [])?.map((error) => {
        return { Date: error?.date, eRegError: error?.errorCount };
      }),
    ]);
  }, [digitalCheckInData]);

  const [showNoData, setShowNoData] = useState(null);
  const parentElement = useRef(null);

  const updateDataAvailability = () => {
    parentElement.current = document?.getElementById('digital-checkIn-analytics');
    if (parentElement?.current?.childNodes?.length <= 0) {
      setShowNoData(true);
    } else {
      setShowNoData(false);
    }
  };

  useEffect(() => {
    onFetchDigitalCheckInData();
    updateDataAvailability();
  }, [hotelId, startDate, endDate, currentChannel]);

  const epoch = (date) => {
    return moment(date).unix();
  };

  useEffect(() => {
    if (digitalCheckInData && digitalCheckInData?.checkInCheckOutGraph?.values) {
      let tempData = JSON.parse(digitalCheckInData?.checkInCheckOutGraph?.values);
      let tempSeries = [
        {
          name: 'Check-in',
          id: `series1`,
          type: 'line',
          data: {
            index: 1,
            aggregation: 'sum',
          },
          style: {
            lineWidth: 2,
            marker: {
              shape: 'circle',
              width: 10,
            },
            lineColor: '#800080',
          },
        },
        {
          name: 'Check-out',
          id: `series2`,
          type: 'line',
          data: {
            index: 2,
            aggregation: 'sum',
          },
          style: {
            lineWidth: 2,
            marker: {
              shape: 'circle',
              width: 10,
            },
            lineColor: '#FFA500',
          },
        },
      ];

      setCheckInAndOutChartData(
        tempData?.map((element, index) => {
          return {
            x: moment(new Date(element?.[0]) * 1000).format(statisticsDataKeys?.dateFormat),
            y: element?.[1],
            z: element?.[2],
            'Check In': element?.[1],
            'Check Out': element?.[2],
          };
        }),
      );
    }
    if (digitalCheckInData && digitalCheckInData?.upsellActivityGraph) {
      let tempData = JSON.parse(digitalCheckInData?.upsellActivityGraph);
      let tempSeries = [
        {
          name: '',
          id: `series1`,
          type: 'line',
          data: {
            index: 1,
            aggregation: 'sum',
          },
          style: {
            lineWidth: 2,
            marker: {
              shape: 'circle',
              width: 10,
            },
            lineColor: '#800080',
          },
        },
      ];

      let tempEndDate = new Date(endDate);

      setUpsellChartData(
        tempData?.map((element, index) => {
          return {
            x: moment(new Date(element[0]) * 1000).format(statisticsDataKeys.dateFormat),
            y: element[1],
            Revenue: element[1],
          };
        }),
      );
      if (document.getElementById('upsell') !== null) {
        let timeChart = new TimeChart({
          container: document.getElementById('upsell'),
          toolbar: {
            fullscreen: true,
            location: 'outside',
            export: false,
          },
          area: {
            maxWidth: 1100,
          },
          currentTime: {
            enabled: false,
          },
          info: {
            showNoData: false,
            showNullData: false,
            showZeroData: false,
          },
          advanced: {
            maxCanvasWidth: 4096,
          },
          series: tempSeries,
          data: {
            units: ['d'],
            timestampInSeconds: true,
            preloaded: {
              dataLimitFrom: epoch(startDate),
              dataLimitTo: epoch(tempEndDate?.setDate(tempEndDate?.getDate() + 1)),
              unit: 'd',
              values: tempData,
            },
          },

          valueAxisDefault: { title: 'Revenue From Upsell' },
        });
      }
    }
    updateDataAvailability();

    if (digitalCheckInData?.errorBreakDown) {
      const groupedErrorDetails = digitalCheckInData?.errorBreakDown?.reduce((error, item) => {
        const { type } = item;
        if (!error[type]) {
          error[type] = [];
        }
        error[type]?.push(item);
        return error;
      }, {});
      setCheckInErrorList(groupedErrorDetails);
    } else {
      setCheckInErrorList({});
    }
  }, [digitalCheckInData]);

  const onFetchDigitalCheckInData = () => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      channel: currentChannel,
    };
    dispatch(fetchDigitalCheckInDetails(payload));
  };

  const addWaterMark = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(150);
      doc.setTextColor('#E5E5E5');
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.5 }));
      doc.text('Hudini', 50, doc.internal.pageSize.height - 50, {
        angle: 45,
      });
      doc.restoreGraphicsState();
    }

    return doc;
  };

  const addPageNumber = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(12);
      doc.setTextColor('#00000');
      doc.text(100, doc.internal.pageSize.height - 5, `${i} of ${totalPages}`);
    }

    return doc;
  };

  const generateCheckInPdf = () => {
    let body = [];
    let header = [];
    if (digitalCheckInData && digitalCheckInData?.checkInCheckOutGraph?.values) {
      let tempData = JSON.parse(digitalCheckInData?.checkInCheckOutGraph?.values);
      body = generateChartPdfExportData(tempData);
      const tempRest = digitalCheckInData?.checkInCheckOutGraph?.labels;
      header = ['Date', ...tempRest];
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    const titleText = 'DIGITAL CHECK-IN';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc.text(70, 50, moment().format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc.text(70, 55, moment(startDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc.text(70, 60, moment(endDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');

    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 80,
      theme: 'striped',
    });

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Digital-Check-in.pdf');
  };

  const generateUpsellPdf = () => {
    let body = [];
    let header = [];
    if (digitalCheckInData && digitalCheckInData?.upsellActivityGraph) {
      let tempData = JSON.parse(digitalCheckInData?.upsellActivityGraph);
      body = generateChartPdfExportData(tempData);
      header = ['Date', 'Value'];
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    const titleText = 'DIGITAL CHECK-IN UPSELL';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc.text(70, 50, moment().format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc.text(70, 55, moment(startDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc.text(70, 60, moment(endDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');

    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 80,
      theme: 'striped',
    });

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Digital-Check-in-upsell.pdf');
  };

  const generateDigitalCheckInPdf = () => {
    let doc = new jsPDF();
    const fontUrl = MyCustomFont;
    const fontName = 'Roboto';
    doc.addFont(fontUrl, fontName, 'normal');
    doc.setFont(fontName);

    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    const titleText = 'ANALYTICS';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);
    const subTitleText = 'Digital Check-in';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc.text(95, 50, moment().format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc.text(95, 55, moment(startDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc.text(95, 60, moment(endDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 70, 'Digital Check-ins (Users):').setFont(undefined, 'normal');
    doc
      .text(
        95,
        70,
        `${digitalCheckInData?.digitalCheckIn?.checkInAdoption?.value || 0} Users, ${
          digitalCheckInData?.digitalCheckIn?.checkInAdoption?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 75, 'Document uploaded (Documents):').setFont(undefined, 'normal');
    doc
      .text(
        95,
        75,
        `${digitalCheckInData?.digitalCheckIn?.documentsUploaded?.value || 0} Documents, ${
          digitalCheckInData?.digitalCheckIn?.documentsUploaded?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 80, 'Payments (Total Payments):').setFont(undefined, 'normal');
    doc
      .text(
        95,
        80,
        `${digitalCheckInData?.digitalCheckIn?.totalPayments?.value || 0} Total Payments, ${
          digitalCheckInData?.digitalCheckIn?.totalPayments?.percentage || 0
        } % success rate`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 85, 'Payments (Total Revenues):').setFont(undefined, 'normal');
    doc.setFont(fontName, 'normal');
    doc
      .text(
        95,
        85,
        `${digitalCheckInData?.digitalCheckIn?.totalPaymentsRevenue?.value || 0} Total Revenue, ${
          digitalCheckInData?.digitalCheckIn?.totalPayments?.percentage || 0
        } % success rate`,
      )
      .setFont(fontName, 'bold');
    doc.text(20, 90, 'Total Key Generation(Keys):').setFont(undefined, 'normal');
    doc
      .text(
        95,
        90,
        `${
          (parseInt(digitalCheckInData?.digitalCheckIn?.totalKeyGeneration?.value) || 0) +
          (parseInt(digitalCheckInData?.digitalCheckIn?.totalKeyGenerationsFailed?.value) || 0)
        } Keys, ${
          (parseFloat(digitalCheckInData?.digitalCheckIn?.totalKeyGeneration?.percentage) || 0) +
          (parseFloat(digitalCheckInData?.digitalCheckIn?.totalKeyGenerationsFailed?.percentage) ||
            0)
        } %`,
      )
      .setFont(undefined, 'bold');

    doc.text(20, 95, 'Successful Keys generation(keys):').setFont(undefined, 'normal');
    doc
      .text(
        95,
        95,
        `${digitalCheckInData?.digitalCheckIn?.totalKeyGeneration?.value || 0} Keys, ${
          digitalCheckInData?.digitalCheckIn?.totalKeyGeneration?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 100, 'Failures Key generation(keys):').setFont(undefined, 'normal');
    doc
      .text(
        95,
        100,
        `${digitalCheckInData?.digitalCheckIn?.totalKeyGenerationsFailed?.value || 0} Keys, ${
          digitalCheckInData?.digitalCheckIn?.totalKeyGenerationsFailed?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');

    doc.text(20, 105, 'Reattempted Check-ins:').setFont(undefined, 'normal');
    doc
      .text(
        95,
        105,
        `${digitalCheckInData?.digitalCheckIn?.reattemptedCheckIns?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.reattemptedCheckIns?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');

    doc.text(20, 110, 'Total Digital Check-ins:').setFont(undefined, 'normal');
    doc
      .text(
        95,
        110,
        `${digitalCheckInData?.digitalCheckIn?.totalCheckIns?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.totalCheckIns?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 115, 'Total Failed Check-ins:').setFont(undefined, 'normal');
    doc
      .text(
        95,
        115,
        `${digitalCheckInData?.digitalCheckIn?.totalFailedCheckIns?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.totalFailedCheckIns?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 120, 'Pre Check-ins:').setFont(undefined, 'normal');
    doc
      .text(
        95,
        120,
        `${digitalCheckInData?.digitalCheckIn?.preCheckIns?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.preCheckIns?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 125, 'Check-in Completed:').setFont(undefined, 'normal');
    doc
      .text(
        95,
        125,
        `${digitalCheckInData?.digitalCheckIn?.checkInCompleted?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.checkInCompleted?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 130, 'E-Registration Received:').setFont(undefined, 'normal');
    doc
      .text(
        95,
        130,
        `${digitalCheckInData?.digitalCheckIn?.eRegistrationsReceived?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.eRegistrationsReceived?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 135, 'Total Revenue:').setFont(undefined, 'normal');
    doc.setFont(fontName, 'normal');
    doc
      .text(
        95,
        135,
        `${digitalCheckInData?.digitalCheckIn?.totalRevenue?.value || 0}, ${
          digitalCheckInData?.digitalCheckIn?.totalRevenue?.percentage || 0
        } %`,
      )
      .setFont(fontName, 'bold');

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Digital-Check-in.pdf');
  };

  const generatePreEmailPdf = () => {
    let doc = new jsPDF();

    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    const titleText = 'DIGITAL CHECK-IN';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');

    doc.setTextColor('#00000');
    doc.setFontSize(24);
    const subTitleText = 'Pre Arrival Emails';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');

    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc.text(80, 50, moment().format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc.text(80, 55, moment(startDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc.text(80, 60, moment(endDate).format('DD/MM/YYYY')).setFont(undefined, 'bold');
    doc.text(20, 70, 'Total Email Sent:').setFont(undefined, 'normal');
    doc
      .text(
        80,
        70,
        `${digitalCheckInData?.preArrivalEmails?.totalEmailsSent?.value || 0}, ${
          digitalCheckInData?.preArrivalEmails?.totalEmailsSent?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 75, 'Total Email Delivered:').setFont(undefined, 'normal');
    doc
      .text(
        80,
        75,
        `${digitalCheckInData?.preArrivalEmails?.totalEmailsDelivered?.value || 0}, ${
          digitalCheckInData?.preArrivalEmails?.totalEmailsDelivered?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 80, 'Check-in Initiated:').setFont(undefined, 'normal');
    doc
      .text(
        80,
        80,
        `${digitalCheckInData?.preArrivalEmails?.checkInInitiated?.value || 0}, ${
          digitalCheckInData?.preArrivalEmails?.checkInInitiated?.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');
    doc.text(20, 85, 'No Responses:').setFont(undefined, 'normal');
    doc
      .text(
        80,
        85,
        `${digitalCheckInData?.preArrivalEmails?.noResponses?.value || 0}, ${
          digitalCheckInData?.preArrivalEmails?.noResponses.percentage || 0
        } %`,
      )
      .setFont(undefined, 'bold');

    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Digital-Pre-Arrival-Email.pdf');
  };

  const formattedValue =
    digitalCheckInData?.digitalCheckIn?.totalRevenue?.formattedValue?.split(' ')[0] || '';

  const numericalValue = (
    digitalCheckInData?.digitalCheckIn?.totalRevenue?.value || 0
  )?.toLocaleString();

  const totalUpsellRevenue = `${formattedValue} ${numericalValue}`; //change "formattedValue" for ticket 5676

  const generateExportData = (data) => {
    return data?.map((item) => ({
      Date: moment(item?.date)?.format(statisticsDataKeys?.dateFormatISO),
      ReservationID: item?.reservationId,
      ErrorMessage: item?.errorMessage || '---',
    }));
  };

  const digitalCheckInMatrix = [
    {
      title: 'Total Digital Check-Ins',
      subTitle: 'Pre Check-In + Check-Ins',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalCheckIns?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Pre Check-Ins Completed',
      subTitle: 'Success Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.preCheckIns?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Check-Ins Completed',
      subTitle: 'Success Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.checkInCompleted?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Total Check-In Errors',
      subTitle: 'Pre Check-In + Check-In',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalFailedCheckIns?.value || 0,
      uniqueCount: digitalCheckInData?.digitalCheckIn?.uniqueCheckInFailures?.value || 0,
    },
    {
      title: 'E-Registrations',
      subTitle: 'Total Submissions',
      totalCount: digitalCheckInData?.digitalCheckIn?.eRegistrationsReceived?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'E-Reg Errors',
      subTitle: 'Errors Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalERegistrationFailures?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Arrival Upsell',
      subTitle: 'Count of Reservation that requested upsell.',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalUpsellCount?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Check-Out',
      subTitle: 'Total Check-Out Count',
      totalCount: digitalCheckInData?.totalCheckOut?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Upsell Revenue',
      subTitle: 'Total Revenue',
      totalCount: `${formattedValue} ${numericalValue}`,
      uniqueCount: '',
    },
    {
      title: 'Payment',
      subTitle: 'Transaction Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalPayments?.value || 0,
      uniqueCount: '',
    },
    {
      title: 'Payment Errors',
      subTitle: 'Transaction Error Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalPaymentFailures?.value || 0,
      uniqueCount: digitalCheckInData?.digitalCheckIn?.uniquePaymentFailures?.value || 0,
    },
    {
      title: 'Key Generation',
      subTitle: 'Success Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalKeyGeneration?.value || 0,
      uniqueCount: digitalCheckInData?.digitalCheckIn?.uniqueKeyGenerations?.value || 0,
    },
    {
      title: 'Key Generation Errors',
      subTitle: 'Unsuccessful Key Generation Count',
      totalCount: digitalCheckInData?.digitalCheckIn?.totalKeyGenerationsFailed?.value || 0,
      uniqueCount: digitalCheckInData?.digitalCheckIn?.uniqueKeyGenerationFailures?.value || 0,
    },
  ];
  return (
    <>
      {showNoData ? (
        <span className='py-2'>
          Unable to generate reports due to third-party integration limitations.
        </span>
      ) : null}
      <div className='d-flex flex-column gap-3' id={'Arrivals'}>
        <CardWrapper
          title='Arrivals'
          hotelName={currentHotelName}
          showLoader={showLoader}
          showAllForReport={showAllForReport}
          setShowAllForReport={setShowAllForReport}
          width='100%'
          showExportButton={true}
          startDate={moment(new Date(startDate)).format(statisticsDataKeys?.errorReportDateFormat)}
          endDate={moment(new Date(endDate)).format(statisticsDataKeys?.errorReportDateFormat)}
          onClickRefreshBtn={onFetchDigitalCheckInData}
          exportData={generateDigitalCheckInPdf}
          excelData={generateTotalReservationExportData(
            digitalCheckInData,
            startDate,
            endDate,
            'digitalCheckIn',
          )}
          isInfo={true}
          isCustom={true}
        >
          <div className='summaryWrapper'>
            <div className='d-flex flex-wrap p-0 my-2'>
              {digitalCheckInMatrix.map((checkIn, index) => (
                <SummaryCardWrapper
                  key={index}
                  title={
                    <>
                      <div className='d-flex justify-content-between head-title'>
                        <span className='ci-title'>{checkIn?.title}</span>
                        {checkIn?.title === 'Total Check-In Errors' &&
                          checkIn?.totalCount > 0 &&
                          !showAllForReport && (
                            <div
                              className='icon-button rounded-circle cursor-pointer col-auto d-flex'
                              onClick={() => {
                                setSelectedErrorKey({
                                  code: digitalCheckInErrorKey?.checkIn,
                                  name: digitalCheckInErrorKey?.failedCheckIn,
                                });
                                setShowMoreDetail(!showMoreDetail);
                              }}
                            >
                              <ManageSearch className='fs-3 p-1' />
                            </div>
                          )}
                        {checkIn?.title === 'E-Reg Errors' &&
                          checkIn?.totalCount !== 'NA' &&
                          checkInErrorList?.[digitalCheckInErrorKey?.eRegistration]?.length > 0 &&
                          !showAllForReport && (
                            <div
                              className='icon-button rounded-circle cursor-pointer col-auto d-flex'
                              onClick={() => {
                                setSelectedErrorKey({
                                  code: digitalCheckInErrorKey?.eRegistration,
                                  name: digitalCheckInErrorKey?.eRegistrationFailures,
                                });
                                setShowMoreDetail(!showMoreDetail);
                              }}
                            >
                              <ManageSearch className='fs-3 p-1' />
                            </div>
                          )}
                        {checkIn?.title === 'Payment Errors' &&
                          checkIn?.totalCount > 0 &&
                          !showAllForReport && (
                            <div
                              className='icon-button rounded-circle cursor-pointer col-auto d-flex'
                              onClick={() => {
                                setSelectedErrorKey({
                                  code: digitalCheckInErrorKey?.payment,
                                  name: digitalCheckInErrorKey?.paymentFailures,
                                });
                                setShowMoreDetail(!showMoreDetail);
                              }}
                            >
                              <ManageSearch className='fs-3 p-1' />
                            </div>
                          )}
                        {checkIn?.title === 'Key Generation Errors' &&
                          checkInErrorList?.[digitalCheckInErrorKey?.keyGeneration]?.length > 0 &&
                          !showAllForReport && (
                            <div
                              className='icon-button rounded-circle cursor-pointer col-auto d-flex'
                              onClick={() => {
                                setSelectedErrorKey({
                                  code: digitalCheckInErrorKey.keyGeneration,
                                  name: digitalCheckInErrorKey.keyGenerationFailures,
                                });
                                setShowMoreDetail(!showMoreDetail);
                              }}
                            >
                              <ManageSearch className='fs-3 p-1' />
                            </div>
                          )}
                      </div>
                    </>
                  }
                  subTitle={checkIn?.subTitle}
                  total={
                    checkIn?.title === 'Total Check-In Errors' ? (
                      <div className='analytic-ci-sub1 col-12'>
                        <div className='d-flex col-12'>
                          <div className='col d-flex flex-column w-100 borderRight'>
                            <div className='fs-6 totalLabel'>Total Count</div>
                            <div className='fs-4'>{checkIn?.totalCount?.toLocaleString()}</div>
                          </div>
                          <div className='col d-flex flex-column w-100'>
                            <div className='fs-6 uniqueLabel'>Unique</div>
                            <div className='fs-4'>{checkIn?.uniqueCount?.toLocaleString()}</div>
                          </div>
                        </div>
                      </div>
                    ) : checkIn?.title === 'E-Reg Errors' && checkIn?.totalCount !== 'NA' ? (
                      <div className='analytic-ci-sub1 col-12'>
                        <div className='analytic-summary-card-total'>
                          {checkIn?.totalCount?.toLocaleString()}
                        </div>
                      </div>
                    ) : checkIn?.title === 'Payment Errors' ? (
                      <div className='analytic-ci-sub1 col-12'>
                        <div className='d-flex col-12'>
                          <div className='col d-flex flex-column w-100 borderRight'>
                            <div className='fs-6 totalLabel'>Total Count</div>
                            <div className='fs-4'>{checkIn?.totalCount?.toLocaleString()}</div>
                          </div>
                          <div className='col d-flex flex-column w-100'>
                            <div className='fs-6 uniqueLabel'>Unique</div>
                            <div className='fs-4'>{checkIn?.uniqueCount?.toLocaleString()}</div>
                          </div>
                        </div>
                      </div>
                    ) : checkIn?.title === 'Key Generation' ? (
                      <div className='analytic-ci-sub1 col-12'>
                        <div className='d-flex col-12'>
                          <div className='col d-flex flex-column w-100 borderRight'>
                            <div className='fs-6 totalLabel'>Total Count</div>
                            <div className='fs-4'>{checkIn?.totalCount?.toLocaleString()}</div>
                          </div>
                          <div className='col d-flex flex-column w-100'>
                            <div className='fs-6 uniqueLabel'>Unique</div>
                            <div className='fs-4'>{checkIn?.uniqueCount?.toLocaleString()}</div>
                          </div>
                        </div>
                      </div>
                    ) : checkIn?.title === 'Key Generation Errors' ? (
                      <div className='analytic-ci-sub1 col-12'>
                        <div className='d-flex col-12'>
                          <div className='col d-flex flex-column w-100 borderRight'>
                            <div className='fs-6 totalLabel'>Total Count</div>
                            <div className='fs-4'>{checkIn?.totalCount?.toLocaleString()}</div>
                          </div>
                          <div className='col d-flex flex-column w-100'>
                            <div className='fs-6 uniqueLabel'>Unique</div>
                            <div className='fs-4'>{checkIn?.uniqueCount?.toLocaleString()}</div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      checkIn?.totalCount?.toLocaleString()
                    )
                  }
                />
              ))}
            </div>
          </div>
        </CardWrapper>

        <div className='statisticsArrival'>
          <Arrival
            key='Arrival'
            allStatisticsData={digitalCheckInData}
            showAllForReport={showAllForReport}
            setShowAllForReport={setShowAllForReport}
            showLoader={showLoader}
          />
        </div>
        {checkInErrorList?.[selectedErrorKey?.code]?.length > 0 && (
          <Drawer
            key={'digital_checkIn'}
            anchor={'right'}
            open={showMoreDetail}
            onClose={() => {
              setShowMoreDetail(false);
              setSelectedErrorKey(null);
            }}
            className='right-drawer'
          >
            <div className='p-2 position-relative overflow-hidden'>
              <div className='col-12'>
                <div className='dismiss-icon d-flex justify-content-end align-items-center'>
                  <div>
                    <ExportPageAsCSV
                      startDate={startDate}
                      endDate={endDate}
                      hotelName={currentHotelName}
                      fileName={`${selectedErrorKey?.name}.csv`}
                      data={generateExportData(checkInErrorList?.[selectedErrorKey?.code])}
                    />
                  </div>
                  <IconButton onClick={() => setShowMoreDetail(false)}>
                    <CancelIcon />
                  </IconButton>
                </div>
              </div>
              <div className='p-4 h-100'>
                <StatisticsItemList
                  title={`${selectedErrorKey?.name} Report`}
                  key={2}
                  showErrorsList={true}
                  columnNames={[
                    statisticsDataKeys?.errorDate,
                    statisticsDataKeys?.reservationId,
                    statisticsDataKeys?.errorMessage,
                  ]}
                  items={checkInErrorList?.[selectedErrorKey?.code]?.map((checkInError, index) => {
                    return {
                      [statisticsDataKeys?.errorDate]: moment(checkInError?.date).format(
                        statisticsDataKeys?.dateFormat,
                      ),
                      [statisticsDataKeys?.reservationId]: checkInError?.reservationId,
                      [statisticsDataKeys?.errorMessage]: checkInError?.errorMessage || '---',
                    };
                  })}
                  showAllForReport={false}
                />
              </div>
            </div>
          </Drawer>
        )}
      </div>
    </>
  );
};

export default DigitalCheckIn;
